/** A plain string is a paragraph; a string array is a bullet list. */
export type FaqBlock = string | string[]

export interface FaqItem {
  question: string
  answer: FaqBlock[]
}

export const faqs: FaqItem[] = [
  {
    question: 'How do I receive the material?',
    answer: [
      'You receive digital access immediately after payment.',
      'The material is delivered in PDF format so you can download it and use it from your phone, tablet, laptop, or computer.',
      'You can also print the pages you want to use courtside.',
    ],
  },
  {
    question: 'Is this only for experienced handball coaches?',
    answer: [
      'No.',
      'HANDBALL 360 READY™ is designed to be practical for developing coaches while still giving experienced coaches a structured system they can adapt.',
      'It is especially useful for:',
      [
        'Club coaches',
        'Youth coaches',
        'Academy coaches',
        'PE teachers',
        'Grassroots coaches',
      ],
    ],
  },
  {
    question: 'Is this only for youth handball?',
    answer: [
      'No.',
      'The system is based on coaching principles, progressions, adaptations, and session organization.',
      'You can adjust:',
      ['Space', 'Speed', 'Pressure', 'Player numbers', 'Complexity'],
      'according to your group.',
    ],
  },
  {
    question: 'Do I have to follow the sessions exactly?',
    answer: [
      'No.',
      'You can open one complete READY 60™ session and run it as written.',
      'Or you can select individual drills, progressions, and coaching tools according to your team’s needs.',
    ],
  },
  {
    question: 'Does it include videos?',
    answer: [
      'No.',
      'HANDBALL 360 READY™ is a 100% visual PDF coaching system.',
      'The goal is simple:',
      ['Open the page.', 'See the setup.', 'Understand the progression.', 'Coach.'],
    ],
  },
  {
    question: 'Can I download and print the material?',
    answer: [
      'Yes.',
      'The PDFs are downloadable.',
      'You can keep them digitally or print the pages and coaching tools you want to use.',
    ],
  },
  {
    question: 'Is it a subscription?',
    answer: [
      'No.',
      'It is a one-time payment.',
      'There is no monthly subscription for the material included in your purchase.',
    ],
  },
  {
    question: 'Is everything in English?',
    answer: ['Yes.', 'The complete system is presented in English.'],
  },
  {
    question: 'How does the 7-day guarantee work?',
    answer: [
      'If you have an access problem, an incomplete file, or the delivered material does not match this offer, contact us within 7 days.',
      'We will first try to solve the problem.',
      'If we cannot resolve it, you will receive a refund.',
    ],
  },
]
